// Generated by ReScript, PLEASE EDIT WITH CARE

import * as CDNConfigJs from "../CDNConfig.js";
import * as Environment$Catalyst from "../node_modules/@porterin/catalyst/src/entities/Environment.bs.js";

var configObj = (require("Config"));

var env = configObj.app_env;

var oms_url = configObj.oms_url;

var sentry_dsn = configObj.sentry_dsn;

var ga_tracking_id = configObj.ga_tracking_id;

var ga_tracking_id_uae = configObj.ga_tracking_id_uae;

var crm_oder_key = configObj.crm_oder_key;

var google_maps_api_key = configObj.google_maps_api_key;

var fare_system_url = configObj.fare_gateway_url;

var atlas_url = configObj.atlas_gateway_url;

var crm_gateway_url = configObj.crm_gateway_url;

var nuclei_url = configObj.nuclei_url;

var cdn_india_prod = CDNConfigJs.cdn_india_prod;

var cdn_uae_prod = CDNConfigJs.cdn_uae_prod;

function getCDNPath(country) {
  switch (country) {
    case "india" :
        if (process.env.IS_GCP) {
          return configObj.gcs_public_path;
        } else {
          return cdn_india_prod;
        }
    case "uae" :
        if (process.env.IS_GCP) {
          return configObj.gcs_public_path;
        } else {
          return cdn_uae_prod;
        }
    default:
      return cdn_india_prod;
  }
}

function getEnv(param) {
  return Environment$Catalyst.fromString(env);
}

function getSentryDsn(param) {
  return sentry_dsn;
}

function getSentrySuppressErrors(param) {
  return [
          /PartnerAppInterface is not defined/i,
          /Java exception was raised during method invocation/i
        ];
}

function getCrmBaseUrl(param) {
  return window.location.origin;
}

function getHostName(param) {
  if (env === "development") {
    return "http://localhost:3000";
  } else {
    return oms_url;
  }
}

function getCrmGatewayUrl(param) {
  if (env === "development") {
    return "http://localhost:3000";
  } else {
    return crm_gateway_url;
  }
}

function getNucleiUrl(param) {
  if (env === "development") {
    return "http://localhost:3000";
  } else {
    return nuclei_url;
  }
}

function getGoogleMapsApiKey(param) {
  return google_maps_api_key;
}

function getDefaultCampaignCustomerId(param) {
  return "07cf1718-8101-42c6-943f-7840cfe81cae";
}

function getMapMyIndiaApiKey(param) {
  return process.env.MAP_MY_INDIA_API_KEY;
}

var orderDetailGMapLibs = ["geometry"];

var placeOrderGMapsLibrary = [
  "places",
  "geometry"
];

function getCurrentHostname(param) {
  return window.location.hostname;
}

function getGaTrackingId(param) {
  return ga_tracking_id;
}

var Env = {
  env: env,
  oms_url: oms_url,
  sentry_dsn: sentry_dsn,
  ga_tracking_id: ga_tracking_id,
  ga_tracking_id_uae: ga_tracking_id_uae,
  dd_app_id: "process.env.DD_APP_ID",
  crm_oder_key: crm_oder_key,
  google_maps_api_key: google_maps_api_key,
  fare_system_url: fare_system_url,
  atlas_url: atlas_url,
  crm_gateway_url: crm_gateway_url,
  nuclei_url: nuclei_url,
  cdn_india_prod: cdn_india_prod,
  cdn_uae_prod: cdn_uae_prod,
  getCDNPath: getCDNPath,
  getEnv: getEnv,
  getSentryDsn: getSentryDsn,
  getSentrySuppressErrors: getSentrySuppressErrors,
  getCrmBaseUrl: getCrmBaseUrl,
  getHostName: getHostName,
  getCrmGatewayUrl: getCrmGatewayUrl,
  getNucleiUrl: getNucleiUrl,
  getGoogleMapsApiKey: getGoogleMapsApiKey,
  getDefaultCampaignCustomerId: getDefaultCampaignCustomerId,
  getMapMyIndiaApiKey: getMapMyIndiaApiKey,
  orderDetailGMapLibs: orderDetailGMapLibs,
  placeOrderGMapsLibrary: placeOrderGMapsLibrary,
  getCurrentHostname: getCurrentHostname,
  getGaTrackingId: getGaTrackingId
};

var ExternalScripts = {
  mapMyIndia: "https://apis.mapmyindia.com/advancedmaps/v1/f5boruhj1ha1ylh4nehduoggherhmg8d/map_load?v=1.5"
};

export {
  configObj ,
  Env ,
  ExternalScripts ,
  
}
/* configObj Not a pure module */
